import React from "react";
import { CustomerDetail } from "components/pages"

export interface CustomerDetailPageProps {};

const CustomerDetailPage: React.FC<CustomerDetailPageProps> = () => {
    return <CustomerDetail />
}

export default CustomerDetailPage;